import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../../../../ui/Progress";
import {useMediaQuery} from "react-responsive";
import {getMasterClassFull,
  getMasterClassCard,
  getMasterClassSystemInfo} from "../../store/actions";
import {updateMasterClass, changeMasterClassStatus} from "../../store/send";
import {deleteMasterClass} from "../../store/delete";
import TopBar from "./TopBar";
import Tabs from "../../../../../../ui/Tabs";
import Box from "../../../../../../ui/Box";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import MainInfo from "./MainInfo";
import MasterClassDrawer from "../../components/MasterClassDrawer";
import Students from "./Students";

const useStyles = makeStyles(() => ({
  mainRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  infoForm: {
    marginBottom: 24
  },
  caption: {
    color: '#778899',
    fontSize: 10,
    marginBottom: 16
  },
  fileInput: {
    display: 'none'
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "/work/app/manage/resources/programs"
  },
  {
    label: "Мои мастер-классы",
    link: "/work/app/manage/resources/programs/my-master-classes"
  },
];

const tabitems = [
  {number: 0, caption: "Основные параметры"},
  {number: 1, caption: "Обучающиеся"}
];

const initialState = {
  deleteModalOpen: false,
  editableMain: null,
  isEdited: true
};

const MasterClassView = ({match, history,
                           masterClassSystemInfo,
                           masterClassFullInfo,
                           getMasterClassSystemInfo,
                           getMasterClassFull,
                           getMasterClassCard,
                           updateMasterClass,
                           deleteMasterClass,
                           changeMasterClassStatus,
                           isUpdatingMasterClass, isChangingStatus,
                           updatedMasterClass}) => {
  const {id} = match.params;
  const classes = useStyles();
  const [isEditable, setEditable] = React.useState(false);
  const [state, setStateObject] = React.useState(initialState);

  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});
  const returnBack = () => {
    history.push("/work/app/manage/resources/programs/my-master-classes");
  }

  useEffect(() => {
    getMasterClassSystemInfo(id);
    getMasterClassFull(id);
  }, [id]);

  const setState = (field, value) => {
    setStateObject({
      ...state,
      [field]: value
    });
  };

  useEffect(() => {
    if (updatedMasterClass && updatedMasterClass.success) {
      setEditable(false);
    }
  }, [updatedMasterClass]);

  const onReload = () => {
    getMasterClassSystemInfo(id);
    getMasterClassFull(id);
    getMasterClassCard(id);
  };

  return(
    <div>
      <Breadcrumbs items={items} />
      {masterClassSystemInfo ?
        <div className={classes.mainRoot}>
          <DeleteConfirmationModal
            modalText="Удалить мастер-класс?"
            open={state.deleteModalOpen}
            onConfirm={() => {
              deleteMasterClass(id);
              returnBack();
            }}
            handleClose={() => setState("deleteModalOpen", false)}
          />
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={onReload}
                returnBack={returnBack}
                update={() => {
                  setState("isEdited", true);
                  updateMasterClass(id, state.editableMain);
                }}
                statusId={masterClassSystemInfo.status}
                isUpdating={isUpdatingMasterClass || isChangingStatus}
                openDeleteModal={() => setState("deleteModalOpen", true)}
                startRecruiting={() => changeMasterClassStatus(id, "send-to-start")}
                stopRecruiting={() => changeMasterClassStatus(id, "send-to-stop")}
                disabled={!state.isEdited}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                <MainInfo editmode={isEditable}
                          disabled={!masterClassSystemInfo.editable}
                          mcId={id}
                          onFormChange={formState => {
                            setState("editableMain", formState);
                          }}/>
              </Box>
              <Box noMargin>
                <Students id={id} masterClassName={(masterClassFullInfo && masterClassFullInfo.data) ? masterClassFullInfo.data.name : ''}/>
              </Box>
            </Tabs>
          </div>
          {isLarge &&
          <MasterClassDrawer mcId={id} open hideLink />}
        </div> : <Progress/>}
    </div>
  )
};

const mapStateToProps = state => ({
  masterClassSystemInfo: state.masterClasses.masterClassSystemInfo,
  isUpdatingMasterClass: state.masterClasses.isUpdatingMasterClass,
  updatedMasterClass: state.masterClasses.updatedMasterClass,
  isChangingStatus: state.masterClasses.isChangingStatus,
  masterClassFullInfo: state.masterClasses.masterClassFullInfo,
});

const mapDispatchToProps = dispatch => ({
  getMasterClassSystemInfo: (id) => dispatch(getMasterClassSystemInfo(id)),
  getMasterClassFull: (id) => dispatch(getMasterClassFull(id)),
  getMasterClassCard: (id) => dispatch(getMasterClassCard(id)),
  updateMasterClass: (id, main) => dispatch(updateMasterClass(id, main)),
  deleteMasterClass: (id) => dispatch(deleteMasterClass(id)),
  changeMasterClassStatus: (id, actionName) => dispatch(changeMasterClassStatus(id, actionName))
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterClassView);
